import React from 'react'

import ActionBase from 'components/pages/quarantineAction/ActionBase'
import SenderAllowed from 'assets/images/qn2c/senderAllowed.svg'
import ContentHeader from 'components/pages/quarantineAction/ContentHeader'

export interface AllowActionProps {
  user: string
  headerFrom: string
  subject: string
  date: string
  onClick: () => void
  buttonLabel: string
  buttonBdsType: 'interactiveNeutral' | 'interactiveEmphasis'
  error: boolean
  errorContent: string
  loading: boolean
  icon?: boolean
  initial: string
  content: 'allowSuccess' | 'allowContent'
}

export const AllowAction: React.FC<AllowActionProps> = ({
  user,
  headerFrom,
  subject,
  date,
  onClick,
  buttonLabel,
  buttonBdsType,
  error,
  errorContent,
  loading,
  icon,
  content,
  initial
}) => (
  <ActionBase
    onClick={onClick}
    buttonLabel={buttonLabel}
    buttonBdsType={buttonBdsType}
    error={error}
    errorContent={errorContent}
    loading={loading}
    icon={icon ? <img src={SenderAllowed} alt="Allowed" /> : undefined}
  >
    {content === 'allowSuccess' ? (
      <ContentHeader
        user={user}
        headerFrom={headerFrom}
        content={{
          header: 'Message delivered and sender allowed',
          subHeader:
            'Message successfully released to your inbox and sender added to your allow list. You may close this window.'
        }}
        info="EmailInfo"
        subject={subject}
        date={date}
      />
    ) : (
      <ContentHeader
        user={user}
        headerFrom={headerFrom}
        subject={subject}
        date={date}
        initial={initial}
        info="AllowContent"
        content={{
          header: 'Deliver message and always allow sender?',
          subHeader: ''
        }}
      />
    )}
  </ActionBase>
)

export default AllowAction
